import React, { useEffect, useState } from "react";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import CancelIcon from "@mui/icons-material/Close";
import EditableTable from "components/smea/Table/EditableTable";
import exportFunction from "functions/smea/export-function";
import useAxiosPrivate from "contexts/interceptors/axios";
import CRPerSubjectModal from "./SchoolCRPerSubject";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "absolute",
  backgroundColor: "#e9e9e9",
  // background:
  //   "linear-gradient(40deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9))",
  //   border: "solid 2px #46e3be",
  boxShadow: "3px 2px 20px 3px rgba(0, 0, 0, 0.3)",
  borderRadius: "10px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  p: 2,
  overflow: "auto",
  minHeight: "80vh",
  "@media (min-width: 10px)": {
    width: "85vw",
  },

  "@media (min-width: 480px)": {
    width: "80vw",
  },

  "@media (min-width: 640px)": {
    width: "70vw",
  },

  "@media (min-width: 768px)": {
    width: "70vw",
  },

  "@media (min-width: 1024px)": {
    width: "70vw",
  },

  "@media (min-width: 1082px)": {
    width: "70vw",
  },
};

export default function SchoolsCompletionRateModal({
  open,
  handleClose,
  data,
  loadingState,
  error,
  quarter,
  schoolYear,
}) {
  const axiosPrivate = useAxiosPrivate();
  const [rowToView, setRowToView] = useState();
  const [rowToGenerate, setRowToGenerate] = useState();
  const [openCRPerSub, setOpenCRPerSub] = useState(false);
  const [loading, setLoading] = useState(false);
  const [exportError, setExportError] = useState(error || "");

  useEffect(() => {
    if (rowToView) {
      setOpenCRPerSub(true);
    }
    if (rowToGenerate) {
      setLoading(true);
      setExportError("");
      const dataGenerate = rowToGenerate[0];

      if (quarter) {
        axiosPrivate
          .get(`/competency/schoolConsolidatedData`, {
            params: {
              schoolId: dataGenerate?.id,
              quarter,
              schoolYear,
            },
          })
          .then((e) => {
            const results = e?.data;

            exportFunction.downloadData(results, dataGenerate?.officeName);
          })
          .catch((err) => {
            setExportError(err?.message);
          })
          .finally(() => {
            setLoading(false);
            setRowToGenerate();
          });
      } else {
        setLoading(false);
        setExportError("Quarter is not specified");

        setRowToGenerate();
      }
    }
  }, [rowToView, rowToGenerate]);

  const columns = [
    { field: "officeName", headerName: "School/Office", width: 400 },
    { field: "completionRate", headerName: "Completion Rate", width: 200 },
  ];

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
      }}
    >
      <Box sx={style}>
        <Box
          sx={{
            position: "absolute",
            right: 20,
            cursor: "pointer",
            zIndex: 100,
          }}
        >
          <IconButton onClick={handleClose} sx={{ p: 0 }}>
            <CancelIcon />
          </IconButton>
        </Box>

        <CRPerSubjectModal
          open={openCRPerSub}
          handleClose={() => {
            setOpenCRPerSub(false);
            setRowToView();
          }}
          selectedRow={rowToView}
          quarter={quarter}
          schoolYear={schoolYear}
        />
        {exportError}
        {loading}
        <Box>
          <Box
            sx={{
              background: "linear-gradient(120deg, #cf1515, #9319a6)",
              borderRadius: "10px",
              width: "70%",
              p: 2,
              mb: 2,
            }}
          >
            <Typography
              sx={{ ml: 4, fontSize: 25, fontWeight: "bold", color: "#fff" }}
            >
              SCHOOLS COMPLETION RATE
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 1)",
              boxShadow: "8px 8px 15px 3px rgba(0, 0, 0, 0.3)",
              borderRadius: "10px",
              p: 2,
              mx: 2,
            }}
          >
            {error}
            <EditableTable
              data={data}
              columns={columns}
              loading={loadingState}
              height="60vh"
              showSearch
              view="View CR Per Subject"
              generate="Export Report"
              rowToView={setRowToView}
              rowToGenerate={setRowToGenerate}
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
